var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 21,
    viewBox: "0 0 31 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.5 19.2198V19.8735V20.4089V21H31.5V20.4089V19.8735V19.2198H-0.5Z",
    fill: "#D10014"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.5 17.7944V18.2534V18.7888V19.2199H31.5V18.7888V18.2534V17.7944H-0.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.5 16.0212V16.6401V17.1755V17.7944H31.5V17.1755V16.6401V16.0212H-0.5Z",
    fill: "#D10014"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.5 14.5957V15.0268V15.5623V16.0212H31.5V15.5623V15.0268V14.5957H-0.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.5 12.8156V13.4066V13.942V14.5957H31.5V13.942V13.4066V12.8156H-0.5Z",
    fill: "#D10014"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.5 11.39V11.7933V12.3288V12.8155H31.5V12.3288V11.7933V11.39H-0.5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.5 9.60999V10.1802V10.7156V11.3901H31.5V10.7156V10.1802V9.60999H-0.5Z",
    fill: "#D10014"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.5 8.18445V8.55994V9.10233V9.60994H31.5V9.10233V8.55994V8.18445H-0.5Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.5 6.4043V6.94668V7.48211V8.18443H31.5V7.48211V6.94668V6.4043H-0.5Z",
    fill: "#D10014"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.5 4.98572V5.3334V5.86883V6.40426H31.5V5.86883V5.3334V4.98572H-0.5Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.5 3.20569V3.7133V4.25569V4.98582H31.5V4.25569V3.7133V3.20569H-0.5Z",
    fill: "#D10014"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.5 1.78015V2.10002V2.63545V3.20565H31.5V2.63545V2.10002V1.78015H-0.5Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.5 0V0.486755V1.02219V1.78013H31.5V1.02219V0.486755V0H-0.5Z",
    fill: "#D10014"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.222 0H-0.5V11.3901H15.222V0Z",
    fill: "#034A79"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0.801937 0.695312L0.984915 1.0569H1.38606L1.09752 1.38372L1.16789 1.77313L0.801937 1.60624L0.443019 1.78008L0.513395 1.38372L0.224854 1.0569H0.625997L0.801937 0.695312Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41994 0.695312L3.60291 1.0569H4.00406L3.71552 1.38372L3.77885 1.77313L3.41994 1.60624L3.06102 1.78008L3.13139 1.38372L2.83582 1.0569H3.244L3.41994 0.695312Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03798 0.695312L6.21392 1.0569H6.6221L6.32652 1.38372L6.3969 1.77313L6.03798 1.60624L5.67906 1.78008L5.74944 1.38372L5.45386 1.0569H5.855L6.03798 0.695312Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6559 0.695312L8.83184 1.0569H9.23298L8.94444 1.38372L9.01482 1.77313L8.6559 1.60624L8.28994 1.78008L8.36032 1.38372L8.07178 1.0569H8.47292L8.6559 0.695312Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2669 0.695312L11.4498 1.0569H11.851L11.5624 1.38372L11.6258 1.77313L11.2669 1.60624L10.9079 1.78008L10.9783 1.38372L10.6827 1.0569H11.0909L11.2669 0.695312Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8849 0.695312L14.0679 1.0569H14.469L14.1805 1.38372L14.2438 1.77313L13.8849 1.60624L13.526 1.78008L13.5964 1.38372L13.3008 1.0569H13.7019L13.8849 0.695312Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0.801937 2.89966L0.984915 3.2682H1.38606L1.09752 3.58807L1.16789 3.97747L0.801937 3.81059L0.443019 3.99138L0.513395 3.58807L0.224854 3.2682H0.625997L0.801937 2.89966Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41994 2.89966L3.60291 3.2682H4.00406L3.71552 3.58807L3.77885 3.97747L3.41994 3.81059L3.06102 3.99138L3.13139 3.58807L2.83582 3.2682H3.244L3.41994 2.89966Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03798 2.89966L6.21392 3.2682H6.6221L6.32652 3.58807L6.3969 3.97747L6.03798 3.81059L5.67906 3.99138L5.74944 3.58807L5.45386 3.2682H5.855L6.03798 2.89966Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6559 2.89966L8.83184 3.2682H9.23298L8.94444 3.58807L9.01482 3.97747L8.6559 3.81059L8.28994 3.99138L8.36032 3.58807L8.07178 3.2682H8.47292L8.6559 2.89966Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2669 2.89966L11.4498 3.2682H11.851L11.5624 3.58807L11.6258 3.97747L11.2669 3.81059L10.9079 3.99138L10.9783 3.58807L10.6827 3.2682H11.0909L11.2669 2.89966Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8849 2.89966L14.0679 3.2682H14.469L14.1805 3.58807L14.2438 3.97747L13.8849 3.81059L13.526 3.99138L13.5964 3.58807L13.3008 3.2682H13.7019L13.8849 2.89966Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0.801937 5.104L0.984915 5.47255H1.38606L1.09752 5.79241L1.16789 6.18182L0.801937 6.01493L0.443019 6.19573L0.513395 5.79241L0.224854 5.47255H0.625997L0.801937 5.104Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41994 5.104L3.60291 5.47255H4.00406L3.71552 5.79241L3.77885 6.18182L3.41994 6.01493L3.06102 6.19573L3.13139 5.79241L2.83582 5.47255H3.244L3.41994 5.104Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03798 5.104L6.21392 5.47255H6.6221L6.32652 5.79241L6.3969 6.18182L6.03798 6.01493L5.67906 6.19573L5.74944 5.79241L5.45386 5.47255H5.855L6.03798 5.104Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6559 5.104L8.83184 5.47255H9.23298L8.94444 5.79241L9.01482 6.18182L8.6559 6.01493L8.28994 6.19573L8.36032 5.79241L8.07178 5.47255H8.47292L8.6559 5.104Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2669 5.104L11.4498 5.47255H11.851L11.5624 5.79241L11.6258 6.18182L11.2669 6.01493L10.9079 6.19573L10.9783 5.79241L10.6827 5.47255H11.0909L11.2669 5.104Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8849 5.104L14.0679 5.47255H14.469L14.1805 5.79241L14.2438 6.18182L13.8849 6.01493L13.526 6.19573L13.5964 5.79241L13.3008 5.47255H13.7019L13.8849 5.104Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0.801937 7.30823L0.984915 7.67677H1.38606L1.09752 7.99664L1.16789 8.38604L0.801937 8.21915L0.443019 8.39995L0.513395 7.99664L0.224854 7.67677H0.625997L0.801937 7.30823Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41994 7.30823L3.60291 7.67677H4.00406L3.71552 7.99664L3.77885 8.38604L3.41994 8.21915L3.06102 8.39995L3.13139 7.99664L2.83582 7.67677H3.244L3.41994 7.30823Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03798 7.30823L6.21392 7.67677H6.6221L6.32652 7.99664L6.3969 8.38604L6.03798 8.21915L5.67906 8.39995L5.74944 7.99664L5.45386 7.67677H5.855L6.03798 7.30823Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6559 7.30823L8.83184 7.67677H9.23298L8.94444 7.99664L9.01482 8.38604L8.6559 8.21915L8.28994 8.39995L8.36032 7.99664L8.07178 7.67677H8.47292L8.6559 7.30823Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2669 7.30823L11.4498 7.67677H11.851L11.5624 7.99664L11.6258 8.38604L11.2669 8.21915L10.9079 8.39995L10.9783 7.99664L10.6827 7.67677H11.0909L11.2669 7.30823Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8849 7.30823L14.0679 7.67677H14.469L14.1805 7.99664L14.2438 8.38604L13.8849 8.21915L13.526 8.39995L13.5964 7.99664L13.3008 7.67677H13.7019L13.8849 7.30823Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0.801937 9.51953L0.984915 9.88112H1.38606L1.09752 10.2079L1.16789 10.5904L0.801937 10.4235L0.443019 10.6043L0.513395 10.201L0.224854 9.88112H0.625997L0.801937 9.51953Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41994 9.51953L3.60291 9.88112H4.00406L3.71552 10.2079L3.77885 10.5904L3.41994 10.4235L3.06102 10.6043L3.13139 10.201L2.83582 9.88112H3.244L3.41994 9.51953Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03798 9.51953L6.21392 9.88112H6.6221L6.32652 10.2079L6.3969 10.5904L6.03798 10.4235L5.67906 10.6043L5.74944 10.201L5.45386 9.88112H5.855L6.03798 9.51953Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6559 9.51953L8.83184 9.88112H9.23298L8.94444 10.2079L9.01482 10.5904L8.6559 10.4235L8.28994 10.6043L8.36032 10.201L8.07178 9.88112H8.47292L8.6559 9.51953Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2669 9.51953L11.4498 9.88112H11.851L11.5624 10.2079L11.6258 10.5904L11.2669 10.4235L10.9079 10.6043L10.9783 10.201L10.6827 9.88112H11.0909L11.2669 9.51953Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8849 9.51953L14.0679 9.88112H14.469L14.1805 10.2079L14.2438 10.5904L13.8849 10.4235L13.526 10.6043L13.5964 10.201L13.3008 9.88112H13.7019L13.8849 9.51953Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16021 1.81494L2.34319 2.18348H2.74434L2.45579 2.50335L2.51913 2.89276L2.16021 2.72587L1.8013 2.90666L1.87167 2.50335L1.58313 2.18348H1.98427L2.16021 1.81494Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77821 1.81494L4.96119 2.18348H5.36233L5.06676 2.50335L5.13713 2.89276L4.77821 2.72587L4.4193 2.90666L4.48967 2.50335L4.19409 2.18348H4.59524L4.77821 1.81494Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39613 1.81494L7.57207 2.18348H7.97322L7.68468 2.50335L7.75505 2.89276L7.39613 2.72587L7.03721 2.90666L7.10055 2.50335L6.81201 2.18348H7.21316L7.39613 1.81494Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0071 1.81494L10.1901 2.18348H10.5913L10.3027 2.50335L10.3731 2.89276L10.0071 2.72587L9.64822 2.90666L9.7186 2.50335L9.43005 2.18348H9.8312L10.0071 1.81494Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6251 1.81494L12.8081 2.18348H13.2093L12.9207 2.50335L12.9841 2.89276L12.6251 2.72587L12.2662 2.90666L12.3366 2.50335L12.041 2.18348H12.4492L12.6251 1.81494Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16021 4.01917L2.34319 4.38771H2.74434L2.45579 4.70758L2.51913 5.09698L2.16021 4.93009L1.8013 5.11089L1.87167 4.70758L1.58313 4.38771H1.98427L2.16021 4.01917Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77821 4.01917L4.96119 4.38771H5.36233L5.06676 4.70758L5.13713 5.09698L4.77821 4.93009L4.4193 5.11089L4.48967 4.70758L4.19409 4.38771H4.59524L4.77821 4.01917Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39613 4.01917L7.57207 4.38771H7.97322L7.68468 4.70758L7.75505 5.09698L7.39613 4.93009L7.03721 5.11089L7.10055 4.70758L6.81201 4.38771H7.21316L7.39613 4.01917Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0071 4.01917L10.1901 4.38771H10.5913L10.3027 4.70758L10.3731 5.09698L10.0071 4.93009L9.64822 5.11089L9.7186 4.70758L9.43005 4.38771H9.8312L10.0071 4.01917Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6251 4.01917L12.8081 4.38771H13.2093L12.9207 4.70758L12.9841 5.09698L12.6251 4.93009L12.2662 5.11089L12.3366 4.70758L12.041 4.38771H12.4492L12.6251 4.01917Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16021 6.23047L2.34319 6.59206H2.74434L2.45579 6.91193L2.51913 7.30133L2.16021 7.13444L1.8013 7.31524L1.87167 6.91193L1.58313 6.59206H1.98427L2.16021 6.23047Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77821 6.23047L4.96119 6.59206H5.36233L5.06676 6.91193L5.13713 7.30133L4.77821 7.13444L4.4193 7.31524L4.48967 6.91193L4.19409 6.59206H4.59524L4.77821 6.23047Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39613 6.23047L7.57207 6.59206H7.97322L7.68468 6.91193L7.75505 7.30133L7.39613 7.13444L7.03721 7.31524L7.10055 6.91193L6.81201 6.59206H7.21316L7.39613 6.23047Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0071 6.23047L10.1901 6.59206H10.5913L10.3027 6.91193L10.3731 7.30133L10.0071 7.13444L9.64822 7.31524L9.7186 6.91193L9.43005 6.59206H9.8312L10.0071 6.23047Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6251 6.23047L12.8081 6.59206H13.2093L12.9207 6.91193L12.9841 7.30133L12.6251 7.13444L12.2662 7.31524L12.3366 6.91193L12.041 6.59206H12.4492L12.6251 6.23047Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16021 8.43481L2.34319 8.7964H2.74434L2.45579 9.12322L2.51913 9.50567L2.16021 9.33879L1.8013 9.51958L1.87167 9.11627L1.58313 8.7964H1.98427L2.16021 8.43481Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77821 8.43481L4.96119 8.7964H5.36233L5.06676 9.12322L5.13713 9.50567L4.77821 9.33879L4.4193 9.51958L4.48967 9.11627L4.19409 8.7964H4.59524L4.77821 8.43481Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39613 8.43481L7.57207 8.7964H7.97322L7.68468 9.12322L7.75505 9.50567L7.39613 9.33879L7.03721 9.51958L7.10055 9.11627L6.81201 8.7964H7.21316L7.39613 8.43481Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0071 8.43481L10.1901 8.7964H10.5913L10.3027 9.12322L10.3731 9.50567L10.0071 9.33879L9.64822 9.51958L9.7186 9.11627L9.43005 8.7964H9.8312L10.0071 8.43481Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6251 8.43481L12.8081 8.7964H13.2093L12.9207 9.12322L12.9841 9.50567L12.6251 9.33879L12.2662 9.51958L12.3366 9.11627L12.041 8.7964H12.4492L12.6251 8.43481Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsa);
export default __webpack_public_path__ + "static/media/USA.8dd3b591474679f3b7665e429eb8a5cf.svg";
export { ForwardRef as ReactComponent };